import * as Cookie from 'js-cookie';
import { MeasuredCookieType } from './types';
import { cookieKey } from './constants';
var MeasuredCookie = /** @class */ (function () {
    function MeasuredCookie() {
    }
    MeasuredCookie.get = function (type) {
        var current = this.decode(Cookie.get(cookieKey));
        return current[type];
    };
    MeasuredCookie.write = function (type, size) {
        if (!window) {
            return;
        }
        var current = this.decode(Cookie.get(cookieKey));
        current[type] = size;
        Cookie.set(cookieKey, this.encode(current), {
            domain: ".deviantart.".concat(process.env.NODE_ENV === 'development' ? 'lan' : 'com'),
            sameSite: 'lax',
        });
    };
    // decodes 0:110;1:344 to { 0: 110, 1: 344 }
    MeasuredCookie.decode = function (store) {
        var stored = {};
        if (!store) {
            return stored;
        }
        var keyvals = store.split(';');
        if (keyvals.length === 0) {
            return stored;
        }
        var typeToDim = keyvals.map(function (v) { return v.split(':'); });
        if (typeToDim.length === 0) {
            return stored;
        }
        for (var _i = 0, typeToDim_1 = typeToDim; _i < typeToDim_1.length; _i++) {
            var typeDim = typeToDim_1[_i];
            if (typeDim.length !== 2 || !MeasuredCookieType[typeDim[0]]) {
                continue;
            }
            var sizes = typeDim[1].split('x');
            if (sizes.length > 2) {
                continue;
            }
            stored[typeDim[0]] =
                sizes.length === 1
                    ? parseInt(sizes[0])
                    : [parseInt(sizes[0]), parseInt(sizes[1])];
        }
        return stored;
    };
    MeasuredCookie.encode = function (stored) {
        var store = [];
        for (var key in stored) {
            if (!MeasuredCookieType[key]) {
                continue;
            }
            var value = Array.isArray(stored[key])
                ? stored[key].join('x')
                : stored[key];
            store.push("".concat(key, ":").concat(value));
        }
        return store.join(';');
    };
    return MeasuredCookie;
}());
export { MeasuredCookie };
//# sourceMappingURL=MeasuredCookie.js.map